import {
  HStack,
  Icon,
  Link,
  Tooltip,
  Text,
  Skeleton,
} from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  LouiseOffer,
  QuoteProductDocument,
} from '../../../../../../../../types/Quotes';
import GrayTextBox from '../../../../../../../company-scan/components/GrayTextBox';

interface Props {
  offer: LouiseOffer;
  isLoading?: boolean;
  documents?: QuoteProductDocument[];
}

const OfferDocuments: React.FC<Props> = ({
  offer,
  isLoading,
  documents = [],
}) => {
  const { t } = useTranslation();

  const documentItems = [
    {
      name: t('TERMS'),
      link: offer.info?.terms || '',
      type: 'TERMS',
    },
    ...(offer.info?.ipid
      ? [
          {
            name: t('IPID'),
            link: offer.info?.ipid || '',
            type: 'IPID',
          },
        ]
      : []),
  ];

  return (
    <GrayTextBox title={t('DOCUMENTS')}>
      {isLoading ? (
        <>
          <DocumentLoading />
          <DocumentLoading />
        </>
      ) : (
        [...documentItems, ...documents].map((document) => (
          <OfferSingleDocument key={document.name} {...document} />
        ))
      )}
    </GrayTextBox>
  );
};

const OfferSingleDocument: React.FC<QuoteProductDocument> = ({
  name,
  link,
}) => {
  const { t } = useTranslation();

  return (
    <HStack color="gray.500">
      <Icon name="GeneralLabelsDocument" />
      {link ? (
        <Link variant="gray" href={link} isExternal>
          {name}
        </Link>
      ) : (
        <Tooltip label={t('This document is currently unavailable')}>
          <Text color="gray.500" cursor="pointer" textStyle="smallBody">
            {name}
          </Text>
        </Tooltip>
      )}
    </HStack>
  );
};

const DocumentLoading: React.FC = () => (
  <HStack w="100%" color="gray.500">
    <Icon name="GeneralLabelsDocument" />
    <Skeleton w="100%" h="4" />
  </HStack>
);

export default OfferDocuments;
